import * as React from "react";
import type { SVGProps } from "react";
const SvgBusRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.792 17H23c.55 0 1-.45 1-1v-6c0-2.21-1.79-4-4-4H3C1.35 6 0 7.35 0 9v7c0 .55.45 1 1 1h2.208a2.502 2.502 0 0 0 4.592-.02c.065.013.132.02.2.02h9a.996.996 0 0 0 .2-.02 2.502 2.502 0 0 0 4.592.02ZM2 12v3h1.208a2.502 2.502 0 0 1 4.592.02A.995.995 0 0 1 8 15h3v-3H2Zm9-2H2V9c0-.55.45-1 1-1h8v2Zm2 2v3h2v-3h-2Zm2-2h-2V8h2v2Zm2 2v3c.068 0 .135.007.2.02a2.502 2.502 0 0 1 4.592-.02H22v-2h-1.59c-.53 0-1.04-.21-1.41-.59l-.41-.41H17Zm5-1h-1.59l-.41-.41c-.37-.38-.88-.59-1.41-.59H17V8h3c1.1 0 2 .9 2 2v1Zm-2 5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5ZM5 16c0 .28.22.5.5.5s.5-.22.5-.5-.22-.5-.5-.5-.5.22-.5.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusRight;
